
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ServicesPage = () => {
  const services = [
    {
      icon: 'ri-shopping-cart-line',
      title: 'Yangın Tüpü Satış',
      description: 'Her türlü yangın söndürme tüpü satışı. Kuru kimyevi tozlu, köpüklü, karbondioksitli ve su bazlı yangın tüpleri.',
      link: '/hizmetlerimiz/yangin-tupu-satis',
      image: 'https://public.readdy.ai/ai/img_res/1f731587142067db69baea78730f3c77.jpg',
    },
    {
      icon: 'ri-drop-line',
      title: 'Yangın Tüpü Dolum',
      description: 'Boşalmış veya süresi dolmuş yangın tüplerinin profesyonel dolum hizmeti. Hızlı ve güvenilir.',
      link: '/hizmetlerimiz/yangin-tupu-dolum',
      image: 'https://readdy.ai/api/search-image?query=technician%20refilling%20red%20fire%20extinguisher%20in%20modern%20service%20workshop%20with%20professional%20equipment%20clean%20white%20industrial%20setting%20safety%20focused%20bright%20lighting&width=600&height=400&seq=service2&orientation=landscape',
    },
    {
      icon: 'ri-tools-line',
      title: 'Yangın Tüpü Bakım & Kontrol',
      description: 'Periyodik bakım ve kontrol hizmetleri. Yasal gerekliliklere uygun raporlama ve etiketleme.',
      link: '/hizmetlerimiz/yangin-tupu-bakim',
      image: 'https://readdy.ai/api/search-image?query=professional%20technician%20inspecting%20fire%20extinguisher%20with%20checklist%20and%20tools%20in%20clean%20white%20service%20center%20safety%20inspection%20quality%20control%20bright%20professional%20environment&width=600&height=400&seq=service3&orientation=landscape',
    },
    {
      icon: 'ri-shield-line',
      title: 'Yangın Söndürme Ekipmanları',
      description: 'Yangın dolapları, hortumlar, aparatlar, uyarı levhaları ve tüm yangın güvenlik ekipmanları.',
      link: '/hizmetlerimiz/yangin-sondurme-ekipmanlari',
      image: 'https://readdy.ai/api/search-image?query=fire%20safety%20equipment%20display%20including%20fire%20hose%20cabinet%20signs%20and%20accessories%20in%20modern%20clean%20white%20showroom%20professional%20safety%20products%20organized%20presentation&width=600&height=400&seq=service4&orientation=landscape',
    },
    {
      icon: 'ri-fire-fill',
      title: 'Baca Temizliği',
      description: 'Ev ve işletmeler için profesyonel baca temizliği hizmeti. Yangın riskini azaltın, verimli ısınma sağlayın.',
      link: '/hizmetlerimiz/baca-temizligi',
      image: 'https://readdy.ai/api/search-image?query=professional%20chimney%20cleaning%20service%20worker%20with%20equipment%20on%20residential%20roof%20clean%20white%20house%20background%20safety%20gear%20bright%20daylight%20professional%20service&width=600&height=400&seq=service5&orientation=landscape',
    },
    {
      icon: 'ri-restaurant-2-line',
      title: 'Davlumbaz & Kanal Temizliği',
      description: 'Restoran ve endüstriyel mutfaklar için davlumbaz ve kanal temizliği. Yangın riskini minimize edin.',
      link: '/hizmetlerimiz/davlumbaz-temizligi',
      image: 'https://readdy.ai/api/search-image?query=commercial%20kitchen%20hood%20cleaning%20service%20in%20modern%20restaurant%20with%20stainless%20steel%20equipment%20professional%20cleaning%20crew%20clean%20white%20walls%20industrial%20kitchen%20maintenance&width=600&height=400&seq=service6&orientation=landscape',
    },
    {
      icon: 'ri-alarm-warning-line',
      title: 'Otomatik Davlumbaz Söndürme Sistemi',
      description: 'Mutfak yangınlarına karşı otomatik söndürme sistemleri. Kurulum, bakım ve periyodik kontrol.',
      link: '/hizmetlerimiz/otomatik-davlumbaz-sondurme-sistemi',
      image: 'https://readdy.ai/api/search-image?query=automatic%20kitchen%20fire%20suppression%20system%20installed%20above%20commercial%20cooking%20equipment%20in%20modern%20restaurant%20kitchen%20clean%20white%20environment%20professional%20safety%20installation&width=600&height=400&seq=service7&orientation=landscape',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-primary-600 to-primary-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <h1 className="font-display font-bold text-5xl md:text-6xl mb-6">
              Hizmetlerimiz
            </h1>
            <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto">
              Yangın güvenliği konusunda ihtiyacınız olan tüm hizmetleri profesyonel ekibimizle sunuyoruz
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {services.map((service, index) => (
              <Link
                key={index}
                to={service.link}
                className="bg-white border-2 border-dark-100 rounded-xl overflow-hidden hover:border-primary-500 hover:shadow-2xl transition-all group cursor-pointer"
              >
                <div className="w-full h-64 overflow-hidden">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-8">
                  <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-6 group-hover:bg-primary-600 transition-colors">
                    <i className={`${service.icon} text-3xl text-primary-600 group-hover:text-white transition-colors`}></i>
                  </div>
                  <h2 className="font-display font-semibold text-2xl text-dark-900 mb-4 group-hover:text-primary-600 transition-colors">
                    {service.title}
                  </h2>
                  <p className="text-dark-600 leading-relaxed mb-4">
                    {service.description}
                  </p>
                  <div className="flex items-center text-primary-600 font-semibold group-hover:translate-x-2 transition-transform whitespace-nowrap">
                    <span>Detaylı Bilgi</span>
                    <i className="ri-arrow-right-line ml-2"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-dark-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display font-bold text-4xl md:text-5xl text-white mb-6">
            Hangi Hizmete İhtiyacınız Var?
          </h2>
          <p className="text-xl text-white/80 mb-8 max-w-2xl mx-auto">
            Size en uygun çözümü bulmak için bizimle iletişime geçin
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link 
              to="/iletisim" 
              className="bg-primary-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-primary-700 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              Teklif Al
            </Link>
            <a 
              href="tel:+905XXXXXXXXX" 
              className="bg-white text-dark-900 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-dark-50 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              Hemen Ara
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;
